<div
  class="page-header-container"
  [ngClass]="{
    'page-header-container-expanded': !sidebarCollapsed,
    'page-header-container-collapsed': sidebarCollapsed,
    'page-header-container-with-side-panel': sidePanelExpanded
  }"
>
  <span class="page-header-title">{{ title }}</span>

  <ng-content></ng-content>
</div>

<breadcrumb class="page-header-breadcrumb" [protocolNumber]="protocolNumber"></breadcrumb>
